import React from 'react';
import { Outlet } from 'react-router-dom';
import { MarketingNavbar } from './MarketingNavbar';
import { MarketingFooter } from './MarketingFooter';

export const MarketingLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <MarketingNavbar />
      <main>
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
};
